<template>

  <Button v-if="mode==='button' && !isFavorite" :label="$t('afterSales.favorite_add')" icon="pi pi-heart" outlined  @click="addFavorite"/>
  <Button v-else-if="mode==='button' && isFavorite" :label="$t('afterSales.favorite_remove')" icon="pi pi-heart-fill"  @click="removeFavorite"/>
  <i v-else-if="mode==='icon' && !isFavorite" class="pi pi-heart"  @click="addFavorite" style="font-weight: bold;"/>
  <i v-else-if="mode==='icon' && isFavorite" class="pi pi-heart-fill"  @click="removeFavorite" style="font-weight: bold;"/>
  
  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('details.dialog_error')"
    :life="3000" 
    @update:visible="dialog.error = $event" />
</template>

<script>
import AfterSalesService from '../../service/AfterSalesService';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import { mapGetters } from 'vuex';
export default {
  components: { 
    IrinoxDialogDark,
  },
  props: {
    docTreeId: Number,
    mode: String, // button or icon
  },
  data() {
    return {
      dialog: {
        error: false,
      },
    }
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
      favorites: 'afterSales/favorites',
    }),
    isFavorite() {
      return this.favorites?.includes(this.docTreeId);
    } 
  },
  created() {
    this.afterSalesService = new AfterSalesService();
  },
  mounted() {
  },
  methods: {
    addFavorite() {
      this.afterSalesService.postFavorite(this.personaltoken, this.docTreeId)
        .then((data) => {
          if(data.code=="200") {
            this.$store.commit('afterSales/favorites', data.body);
          } else {
            console.error(JSON.stringify(data));
            this.dialog.error = true;
          }
        })
        .catch(error => {
          console.error("ERROR "+error);
          this.dialog.error = true;
        });
    },
    removeFavorite() {
      this.afterSalesService.deleteFavorite(this.personaltoken, this.docTreeId)
        .then((data) => {
          if(data.code=="200") {
            this.$store.commit('afterSales/favorites', data.body);
          } else {
            console.error(JSON.stringify(data));
            this.dialog.error = true;
          }
        })
        .catch(error => {
          console.error("ERROR "+error);
          this.dialog.error = true;
        });
    },
  }
}

</script>

<style scoped>
</style>